
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { RolMostrarDirective } from '@core/directives/rol-mostrar.directive';
import RolOcultarDirective from '@core/directives/rol-ocultar.directive';
import { Rol } from '@core/interfaces/roles';
import { PlataformasService } from '@services/plataformas.service';
import { SettingsService } from '@services/settings.service';

interface MenuFooter {
  nombre: string,
  destino: string,
  ocultar: Rol[],
  icono: string
}

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [MatButtonToggleModule, MatIconModule, MatButtonModule, RolOcultarDirective, RouterModule]
})
export class FooterComponent {
  menu:MenuFooter[] = [
    {nombre: "Negociaciones", destino: "/agente/leads",ocultar:["agencia"],icono:"person"},
    {nombre: "Escritorio",destino:"/supervisor",ocultar:["agente"],icono:"person"},
    {nombre: "Vendedores",destino:"/supervisor/vendedores",ocultar:["agente"],icono:"supervisor_account"},
    {nombre: "Agenda", destino: "/agente/agenda",ocultar:["agencia"],icono:"calendar_month"},
    {nombre: "Reportes",destino:"/agente/reportes",ocultar:["agencia"],icono:"summarize"},
    {nombre: "Reportes",destino:"/supervisor/reportes",ocultar:["agente"],icono:"summarize"},
    {nombre: "Novedades", destino: "/novedades",ocultar:["agencia","agente"],icono:"newspaper"},
    {nombre: "Herramientas", destino: "/mas",ocultar:[],icono:"settings"},
    {nombre: "Admin",destino:"/admin",ocultar:["agente","agencia"],icono:"shield_person"},
  ];

  plataforma = inject(PlataformasService);
  settings = inject(SettingsService);

}


//Rehacer a mano con encapsulation, none para que ande angular material
//https://m3.material.io/components/navigation-bar/overview
